import { useEffect, useState } from "react";
import { Container, Image } from "react-bootstrap";
import { useSelector } from "react-redux";
import { getGateSC } from "../../config";
import useWindowDimensions from "../../hooks/dementions";
import { getAppInfo } from "../../store/app/selector";


import "./banner.scss";

const GameBanner = () => {

    const { width } = useWindowDimensions();

    const appInfo = useSelector(state => getAppInfo(state))

    const getBannerSize = () => {

        if (width >= 1200) {
            return 1200;
        } else if (width >= 992) {
            return 992;
        } else if (width >= 768) {
            return 768;
        } else {
            return 576;
        }
    }
    const style = {
    }



    return (
        <>
            <Container style={style} fluid={true} id="game-banner">
                <div className="overlay"></div>

                {appInfo && appInfo.appid && <Image className="banner" alt="" src={"https://cdnphpgames.com/api/public/dl/JZd6qPc5/gg/" + getGateSC(appInfo.gate) + "/apps/" + appInfo.appid + "/imgs/banner/" + getBannerSize() + ".jpg"} />}
                <div className="caption" >
                </div>
            </Container>
        </>
    );
}

export default GameBanner;